import {MechanicProgressCardsPlayerState} from '@colonist/game-states'
import {CardValidatorOrdered} from '../core/card/CardValidatorOrdered'

export class MechanicValidatorProgressCardsPlayer {
    private readonly progressCardsPlayerState: MechanicProgressCardsPlayerState
    progressCards: CardValidatorOrdered

    constructor(developmentCardPlayerState: MechanicProgressCardsPlayerState) {
        this.progressCardsPlayerState = developmentCardPlayerState
        this.progressCards = new CardValidatorOrdered(this.progressCardsPlayerState.progressCards)
    }
}
